import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Page from 'components/pages/Base/Page/Page';

const StyledDealflowEntitiesPage = styled(Page)`
  ${ComponentStyles}
`;

StyledDealflowEntitiesPage.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowEntitiesPage;
